import { environment } from './../../../../environments/environment';
import { Component } from '@angular/core';
import { DemoTask } from './model';
import { DemoModel } from './demomodel';

@Component({
  selector: 'fb-bootstrap',
  templateUrl: './bootstrap.component.html',
  styleUrls: ['./bootstrap.component.sass'],
})
export class BootstrapComponent {
  loading: boolean;

  private _activeTask: any;
  private _availableModels: any;
  private _devMode = environment.developmentMode;
  private _models = JSON.stringify(DemoModel);
  private _task = JSON.stringify(DemoTask);

  get task() {
    return this._activeTask;
  }

  get activeTable() {
    return 'EP_Cases';
  }

  get availableModels() {
    return this._availableModels;
  }

  constructor() {
    this.initTask();
  }

  reset() {
    this.initTask();
  }

  private initTask() {
    if (!this._devMode) {
      return;
    }
    this.loading = true;
    this._availableModels = new Object(JSON.parse(this._models));
    this._activeTask = new Object(JSON.parse(this._task));
    this.loading = false;
  }
}
